import { render, staticRenderFns } from "./MstDeliveryDestGrpListDetails.vue?vue&type=template&id=1dc43062&scoped=true"
import script from "./MstDeliveryDestGrpListDetails.vue?vue&type=script&lang=js"
export * from "./MstDeliveryDestGrpListDetails.vue?vue&type=script&lang=js"
import style0 from "./MstDeliveryDestGrpListDetails.vue?vue&type=style&index=0&id=1dc43062&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc43062",
  null
  
)

export default component.exports